<template>
    <nt-template>
        <router-view></router-view>
    </nt-template>
</template>

<script>
import NtTemplate from '@/components/Utils/NtTemplate'

export default {
  mounted: function () {
    if (this.$route.name === 'ambienteAluno') {
      this.$router.push({ name: 'ambienteAluno.dashboard' })
    }
  },
  components: {
    NtTemplate
  }
}
</script>
